import { render, staticRenderFns } from "./loader.component.html?vue&type=template&id=d630a020&scoped=true&external"
import script from "./loader.component.ts?vue&type=script&lang=ts&external"
export * from "./loader.component.ts?vue&type=script&lang=ts&external"
import style0 from "./loader.component.scss?vue&type=style&index=0&id=d630a020&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d630a020",
  null
  
)

export default component.exports